<template>
  <div>
    <px-view-header title="Cadastro de Centro de Custo"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loadingCentroCusto">
      <px-circular-loading/>
    </div>
    <v-container>
      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            outlined
            required
            hide-details
            maxlength="100"
            class="required rounded-tag-small"
            label="Descrição do Centro de Custo"
            :error="$v.centroCusto.descricao.$error"
            @blur="$v.centroCusto.descricao.$touch()"
            v-model="centroCusto.descricao"
          />
        </v-col>
        <v-col cols="12" sm="5">
          <v-text-field
            dense
            outlined
            hide-details
            maxlength="50"
            class="rounded-tag-small"
            label="Código interno"
            v-model="centroCusto.codigoInterno"
          />
        </v-col>
        <v-col cols="12" sm="1">
          <v-switch dense
                    hide-details
                    class="pa-0 mt-2 mr-2"
                    label="Ativo"
                    color="primary"
                    v-model="centroCusto.ativo"/>
        </v-col>
      </v-row>
      <div class="mt-5">
        <v-btn color="primary"
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="onClickSave"
               :loading="loading">
          Salvar
        </v-btn>
        <v-btn text class="normal-btn-text" @click="onClickBack">Cancelar</v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';
import CentroCustoService from './centro-custo-service';

export default {
  mixins: [validationMixin],
  data() {
    return {
      loading: false,
      loadingCentroCusto: false,
      centroCusto: {
        descricao: null,
        codigoInterno: null,
        ativo: true,
      },
      idCentroCusto: this.$route.params.id,
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Centros de custo' },
      ],
    };
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: 'main.centros-custo' });
    },
    getCentroCusto() {
      this.loadingCentroCusto = true;
      CentroCustoService.get(this.idCentroCusto)
        .then((response) => {
          this.centroCusto = response.data;
        })
        .finally(() => {
          this.loadingCentroCusto = false;
        });
    },
    salvar() {
      this.loading = true;
      this.centroCusto.descricao = this.centroCusto.descricao.trim();
      CentroCustoService.save(this.centroCusto)
        .then(() => {
          this.$toast('Centro de Custo criado com sucesso', { color: 'success' });
          this.onClickBack();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickSave() {
      if (this.validateForm()) {
        return;
      }
      this.salvar();
    },
  },
  created() {
    if (this.idCentroCusto) {
      this.getCentroCusto();
    }
  },
  validations: {
    centroCusto: {
      descricao: {
        required,
      },
    },
  },
};
</script>
